/**
 * s237 (ACROSS-YOUR-PLAN-1 PR C; D-237.34, rule 159) — sort by clicking a column head, built once: A to Z, click again for
 * Z to A (board 12, Contacts' "Who"). The arrow turns; the word beside it says which way. Pure helper `sortByName` too.
 */
export type SortWay = "az" | "za";

export function SortToggle({ label, way, onFlip, words, title, testId }: {
  label: string;
  way: SortWay;
  onFlip: () => void;
  words: { az: string; za: string };
  title: string;
  testId: string;
}) {
  return (
    <button type="button" onClick={onFlip} title={title} aria-label={`${label}, ${words[way]}`}
      className="-ml-1.5 flex min-h-11 items-center gap-1.5 justify-self-start rounded-[8px] px-1.5 hover:bg-warm-stone" data-testid={testId}>
      <span>{label}</span>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
        className={`text-sage-800 transition-transform ${way === "za" ? "rotate-180" : ""}`}><path d="M12 5v14" /><path d="m6 13 6 6 6-6" /></svg>
      <span className="text-[13px] text-warm-muted" data-testid={`${testId}-word`}>{words[way]}</span>
    </button>
  );
}

/** Board 12's order: by the name's last word (a surname, or a company's last word), A to Z or Z to A. Pure, stable. */
export function sortByName<T>(items: readonly T[], nameOf: (t: T) => string, way: SortWay): T[] {
  const key = (t: T) => (nameOf(t).trim().split(/\s+/).pop() ?? "").toLowerCase();
  const sorted = items.map((t, i) => ({ t, i })).sort((a, b) => key(a.t).localeCompare(key(b.t)) || nameOf(a.t).localeCompare(nameOf(b.t)) || a.i - b.i);
  return (way === "za" ? sorted.reverse() : sorted).map((x) => x.t);
}
